export default "__VITE_ASSET__BtJYAsWT__"